// Mirror des properties + refresh UI + affiche le produit dans le popup (Dawn)
(() => {
  const MIRROR_ATTR = "data-perso-mirror";

  function mirrorPropertiesIntoForm(form) {
    form.querySelectorAll(`input[${MIRROR_ATTR}]`).forEach((n) => n.remove());

    const root = form.closest("product-info") || document;
    const fields = Array.from(root.querySelectorAll('[name^="properties["]'));
    const names = Array.from(new Set(fields.map((el) => el.name).filter(Boolean)));

    names.forEach((name) => {
      const group = fields.filter((el) => el.name === name);

      let value = "";
      if (group[0]?.type === "radio") {
        const checked = group.find((r) => r.checked);
        value = checked ? checked.value : "";
      } else {
        value = group[0]?.value ?? "";
      }

      value = String(value).trim();
      if (!value) return;

      const hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = name;
      hidden.value = value;
      hidden.setAttribute(MIRROR_ATTR, "1");
      form.appendChild(hidden);
    });
  }

  async function fetchCartJson() {
    const cartUrl = (window.routes && routes.cart_url) ? `${routes.cart_url}.js` : "/cart.js";
    const res = await fetch(cartUrl, { credentials: "same-origin" });
    return res.json();
  }

  function updateCartBubble(cart) {
    const bubble = document.querySelector(".cart-count-bubble");
    if (!bubble) return;

    const count = cart?.item_count ?? 0;
    bubble.classList.toggle("hidden", count === 0);

    // Dawn a souvent plusieurs spans
    const spans = bubble.querySelectorAll("span");
    spans.forEach((s) => {
      if (s.classList.contains("visually-hidden")) return;
      s.textContent = String(count);
    });
  }

  function getLastAddedItem(cart) {
    if (!cart?.items?.length) return null;
    // En général, l’item ajouté est le dernier
    return cart.items[cart.items.length - 1];
  }

  function ensureNotificationProductContainer() {
    // Dawn: #cart-notification-product
    let el = document.getElementById("cart-notification-product");

    if (!el) {
      const notif = document.querySelector("cart-notification");
      if (!notif) return null;

      // tente aussi une classe éventuelle
      el = notif.querySelector(".cart-notification-product");
      if (el) return el;

      // sinon on crée le container
      el = document.createElement("div");
      el.id = "cart-notification-product";
      notif.prepend(el);
    }
    return el;
  }

  function renderProps(props) {
    const entries = Object.entries(props || {}).filter(([k, v]) => v != null && String(v).trim() !== "");
    if (!entries.length) return "";

    const rows = entries
      .map(([k, v]) => `<div class="cart-notification__property"><strong>${escapeHtml(k)}:</strong> ${escapeHtml(String(v))}</div>`)
      .join("");

    return `<div class="cart-notification__properties">${rows}</div>`;
  }

  function renderNotificationItem(item) {
    const img = item.image || item.featured_image?.url || "";
    const title = item.product_title || item.title || "Produit";
    const url = item.url || "#";
    const variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";

    return `
      <div class="cart-notification__product" style="display:flex; gap:12px; align-items:flex-start; margin-top:12px;">
        ${img ? `<a href="${url}"><img src="${img}" alt="" style="width:64px;height:64px;object-fit:cover;border-radius:8px;"></a>` : ""}
        <div style="min-width:0;">
          <a href="${url}" style="text-decoration:none; color:inherit;">
  <div style="font-weight:600; line-height:1.2;">${escapeHtml(title)}</div>
</a>
          ${variant ? `<div style="opacity:.75; font-size:.9em; margin-top:2px;">${escapeHtml(variant)}</div>` : ""}
          ${renderProps(item.properties)}
        </div>
      </div>
    `;
  }

  function escapeHtml(s) {
    return s
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function openDrawerOrNotification() {
    const drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.open === "function") {
      drawer.open();
      return;
    }
    const notif = document.querySelector("cart-notification");
    if (notif && typeof notif.open === "function") notif.open();
  }

  async function refreshUIAfterAdd() {
    const cart = await fetchCartJson();
    updateCartBubble(cart);

    // Injecte le produit dans le popup
    const item = getLastAddedItem(cart);
    const container = ensureNotificationProductContainer();
    if (item && container) {
      container.innerHTML = renderNotificationItem(item);
    }

    openDrawerOrNotification();
  }

  // Capture: avant le JS Dawn
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.dataset.type !== "add-to-cart-form") return;

      mirrorPropertiesIntoForm(form);

      // laisse le temps à l’ajout panier de se faire, puis refresh UI
      setTimeout(() => {
        refreshUIAfterAdd().catch((err) => console.warn("Refresh UI failed:", err));
      }, 600);
    },
    true
  );
})();